/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CompleteMyLearnAttemptRequest,
    CompleteMyLearnAttemptRequestFromJSON,
    CompleteMyLearnAttemptRequestToJSON,
} from '../models/CompleteMyLearnAttemptRequest';
import {
    type CreateMyLearnAttemptRequest,
    CreateMyLearnAttemptRequestFromJSON,
    CreateMyLearnAttemptRequestToJSON,
} from '../models/CreateMyLearnAttemptRequest';
import {
    type EndMyLearnVisit200Response,
    EndMyLearnVisit200ResponseFromJSON,
    EndMyLearnVisit200ResponseToJSON,
} from '../models/EndMyLearnVisit200Response';
import {
    type HeartbeatMyLearnVisit200Response,
    HeartbeatMyLearnVisit200ResponseFromJSON,
    HeartbeatMyLearnVisit200ResponseToJSON,
} from '../models/HeartbeatMyLearnVisit200Response';
import {
    type LearnArtifact,
    LearnArtifactFromJSON,
    LearnArtifactToJSON,
} from '../models/LearnArtifact';
import {
    type LearnArtifactCreate,
    LearnArtifactCreateFromJSON,
    LearnArtifactCreateToJSON,
} from '../models/LearnArtifactCreate';
import {
    type LearnAttempt,
    LearnAttemptFromJSON,
    LearnAttemptToJSON,
} from '../models/LearnAttempt';
import {
    type LearnVisit,
    LearnVisitFromJSON,
    LearnVisitToJSON,
} from '../models/LearnVisit';
import {
    type MyVisit,
    MyVisitFromJSON,
    MyVisitToJSON,
} from '../models/MyVisit';
import {
    type PutMyLearnAttemptStateRequest,
    PutMyLearnAttemptStateRequestFromJSON,
    PutMyLearnAttemptStateRequestToJSON,
} from '../models/PutMyLearnAttemptStateRequest';
import {
    type RateLimitError,
    RateLimitErrorFromJSON,
    RateLimitErrorToJSON,
} from '../models/RateLimitError';
import {
    type RobotRunResult,
    RobotRunResultFromJSON,
    RobotRunResultToJSON,
} from '../models/RobotRunResult';
import {
    type RunMyLearnRobotRequest,
    RunMyLearnRobotRequestFromJSON,
    RunMyLearnRobotRequestToJSON,
} from '../models/RunMyLearnRobotRequest';
import {
    type UpdateMyLearnVisitRequest,
    UpdateMyLearnVisitRequestFromJSON,
    UpdateMyLearnVisitRequestToJSON,
} from '../models/UpdateMyLearnVisitRequest';

export interface CompleteMyLearnAttemptOperationRequest {
    /**
     * 
     */
    attemptId: string;
    /**
     * 
     */
    completeMyLearnAttemptRequest?: CompleteMyLearnAttemptRequest;
}

export interface CreateMyLearnArtifactRequest {
    /**
     * 
     */
    learnArtifactCreate: LearnArtifactCreate;
}

export interface CreateMyLearnAttemptOperationRequest {
    /**
     * 
     */
    createMyLearnAttemptRequest: CreateMyLearnAttemptRequest;
}

export interface DeleteMyLearnArtifactRequest {
    /**
     * 
     */
    artifactId: string;
}

export interface GetMyLearnAttemptRequest {
    /**
     * 
     */
    attemptId: string;
}

export interface PutMyLearnArtifactRequest {
    /**
     * 
     */
    artifactId: string;
    /**
     * 
     */
    learnArtifactCreate: LearnArtifactCreate;
}

export interface PutMyLearnAttemptStateOperationRequest {
    /**
     * 
     */
    attemptId: string;
    /**
     * 
     */
    putMyLearnAttemptStateRequest: PutMyLearnAttemptStateRequest;
}

export interface RunMyLearnRobotOperationRequest {
    /**
     * 
     */
    attemptId: string;
    /**
     * 
     */
    runMyLearnRobotRequest: RunMyLearnRobotRequest;
}

export interface UpdateMyLearnVisitOperationRequest {
    /**
     * 
     */
    updateMyLearnVisitRequest: UpdateMyLearnVisitRequest;
}

/**
 * 
 */
export class LearnerApi extends runtime.BaseAPI {

    /**
     * Creates request options for completeMyLearnAttempt without sending the request
     */
    async completeMyLearnAttemptRequestOpts(requestParameters: CompleteMyLearnAttemptOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attemptId'] == null) {
            throw new runtime.RequiredError(
                'attemptId',
                'Required parameter "attemptId" was null or undefined when calling completeMyLearnAttempt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/attempts/{attemptId}/complete`;
        urlPath = urlPath.replace('{attemptId}', encodeURIComponent(String(requestParameters['attemptId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteMyLearnAttemptRequestToJSON(requestParameters['completeMyLearnAttemptRequest']),
        };
    }

    /**
     * Mark an attempt complete
     */
    async completeMyLearnAttemptRaw(requestParameters: CompleteMyLearnAttemptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnAttempt>> {
        const requestOptions = await this.completeMyLearnAttemptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnAttemptFromJSON(jsonValue));
    }

    /**
     * Mark an attempt complete
     */
    async completeMyLearnAttempt(requestParameters: CompleteMyLearnAttemptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnAttempt> {
        const response = await this.completeMyLearnAttemptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMyLearnArtifact without sending the request
     */
    async createMyLearnArtifactRequestOpts(requestParameters: CreateMyLearnArtifactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['learnArtifactCreate'] == null) {
            throw new runtime.RequiredError(
                'learnArtifactCreate',
                'Required parameter "learnArtifactCreate" was null or undefined when calling createMyLearnArtifact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/artifacts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LearnArtifactCreateToJSON(requestParameters['learnArtifactCreate']),
        };
    }

    /**
     * An Artifact is what the learner explicitly keeps, as distinct from an Attempt, which is everything they tried.
     * Keep an artifact
     */
    async createMyLearnArtifactRaw(requestParameters: CreateMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnArtifact>> {
        const requestOptions = await this.createMyLearnArtifactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnArtifactFromJSON(jsonValue));
    }

    /**
     * An Artifact is what the learner explicitly keeps, as distinct from an Attempt, which is everything they tried.
     * Keep an artifact
     */
    async createMyLearnArtifact(requestParameters: CreateMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnArtifact> {
        const response = await this.createMyLearnArtifactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMyLearnAttempt without sending the request
     */
    async createMyLearnAttemptRequestOpts(requestParameters: CreateMyLearnAttemptOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createMyLearnAttemptRequest'] == null) {
            throw new runtime.RequiredError(
                'createMyLearnAttemptRequest',
                'Required parameter "createMyLearnAttemptRequest" was null or undefined when calling createMyLearnAttempt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/attempts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMyLearnAttemptRequestToJSON(requestParameters['createMyLearnAttemptRequest']),
        };
    }

    /**
     * A Visit may hold many Attempts, including repeats of the same activity after a role swap.
     * Start an attempt
     */
    async createMyLearnAttemptRaw(requestParameters: CreateMyLearnAttemptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnAttempt>> {
        const requestOptions = await this.createMyLearnAttemptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnAttemptFromJSON(jsonValue));
    }

    /**
     * A Visit may hold many Attempts, including repeats of the same activity after a role swap.
     * Start an attempt
     */
    async createMyLearnAttempt(requestParameters: CreateMyLearnAttemptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnAttempt> {
        const response = await this.createMyLearnAttemptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteMyLearnArtifact without sending the request
     */
    async deleteMyLearnArtifactRequestOpts(requestParameters: DeleteMyLearnArtifactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['artifactId'] == null) {
            throw new runtime.RequiredError(
                'artifactId',
                'Required parameter "artifactId" was null or undefined when calling deleteMyLearnArtifact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/artifacts/{artifactId}`;
        urlPath = urlPath.replace('{artifactId}', encodeURIComponent(String(requestParameters['artifactId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Discard an artifact
     */
    async deleteMyLearnArtifactRaw(requestParameters: DeleteMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMyLearnArtifactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Discard an artifact
     */
    async deleteMyLearnArtifact(requestParameters: DeleteMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMyLearnArtifactRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for endMyLearnVisit without sending the request
     */
    async endMyLearnVisitRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/end`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mints one `takehome` token per participant and returns the URLs. Calling again on an ended visit returns `409` rather than minting fresh links — recovery is `GET /learn/visits/me`, which returns the same links, not a second `end`.  One link **per participant**, so whoever is in `participants` at this moment is who gets one. A second player added late via `PATCH /learn/visits/me` gets a link; one never added leaves with nothing.  **An empty visit is deleted, not ended.** A visit holding zero attempts and zero artifacts is hard-deleted here — nothing minted, no tombstone, no row — because the only thing a year of retention would preserve is a minor\'s display name. The response is still `200`, with **`take_home_links: []`**: render \"nothing saved this time\", not the QR screen. The visit token cascade-deletes with the row, so the next learner call returns `401` rather than `409`; that is expected, and there is nothing to recover. The rule is the same for `close` and the idle sweep — see `API_DRAFT.md` §6.  **Await this call as a boundary.** The count-and-delete is one transaction server-side, but a client that fires `POST /visits/me/artifacts` and `POST /visits/me/end` concurrently can lose the artifact *and* the visit. Treat `end` like the other forced boundary saves (`API_WALKTHROUGH.md` §3.2). 
     * End the visit and mint take-home links
     */
    async endMyLearnVisitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EndMyLearnVisit200Response>> {
        const requestOptions = await this.endMyLearnVisitRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EndMyLearnVisit200ResponseFromJSON(jsonValue));
    }

    /**
     * Mints one `takehome` token per participant and returns the URLs. Calling again on an ended visit returns `409` rather than minting fresh links — recovery is `GET /learn/visits/me`, which returns the same links, not a second `end`.  One link **per participant**, so whoever is in `participants` at this moment is who gets one. A second player added late via `PATCH /learn/visits/me` gets a link; one never added leaves with nothing.  **An empty visit is deleted, not ended.** A visit holding zero attempts and zero artifacts is hard-deleted here — nothing minted, no tombstone, no row — because the only thing a year of retention would preserve is a minor\'s display name. The response is still `200`, with **`take_home_links: []`**: render \"nothing saved this time\", not the QR screen. The visit token cascade-deletes with the row, so the next learner call returns `401` rather than `409`; that is expected, and there is nothing to recover. The rule is the same for `close` and the idle sweep — see `API_DRAFT.md` §6.  **Await this call as a boundary.** The count-and-delete is one transaction server-side, but a client that fires `POST /visits/me/artifacts` and `POST /visits/me/end` concurrently can lose the artifact *and* the visit. Treat `end` like the other forced boundary saves (`API_WALKTHROUGH.md` §3.2). 
     * End the visit and mint take-home links
     */
    async endMyLearnVisit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EndMyLearnVisit200Response> {
        const response = await this.endMyLearnVisitRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyLearnAttempt without sending the request
     */
    async getMyLearnAttemptRequestOpts(requestParameters: GetMyLearnAttemptRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attemptId'] == null) {
            throw new runtime.RequiredError(
                'attemptId',
                'Required parameter "attemptId" was null or undefined when calling getMyLearnAttempt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/attempts/{attemptId}`;
        urlPath = urlPath.replace('{attemptId}', encodeURIComponent(String(requestParameters['attemptId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get an attempt
     */
    async getMyLearnAttemptRaw(requestParameters: GetMyLearnAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnAttempt>> {
        const requestOptions = await this.getMyLearnAttemptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnAttemptFromJSON(jsonValue));
    }

    /**
     * Get an attempt
     */
    async getMyLearnAttempt(requestParameters: GetMyLearnAttemptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnAttempt> {
        const response = await this.getMyLearnAttemptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyLearnVisit without sending the request
     */
    async getMyLearnVisitRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get my visit
     */
    async getMyLearnVisitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyVisit>> {
        const requestOptions = await this.getMyLearnVisitRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyVisitFromJSON(jsonValue));
    }

    /**
     * Get my visit
     */
    async getMyLearnVisit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyVisit> {
        const response = await this.getMyLearnVisitRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for heartbeatMyLearnVisit without sending the request
     */
    async heartbeatMyLearnVisitRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/heartbeat`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Refreshes `last_seen_at` and extends the Visit token\'s TTL. A Visit that stops heartbeating past the session\'s `visit_idle_timeout_seconds` is marked `abandoned` by the idle sweep, which frees the kiosk device. The sweep also mints that visit\'s take-home links, so a tablet that merely slept can still hand its learner their work.  **Every learner write does both of these too** — refreshes `last_seen_at` *and* extends the TTL. One rule: a learner write means the learner is here, for both purposes. The two must move together; refreshing liveness alone would let a Visit be demonstrably active — writes flowing, the sweep never touching it — while its token died at a fixed 900s from mint, producing a bare `401` mid-activity with no links minted and nothing recoverable until the sweep caught up 300s after the learner gave up.  That leaves this route a real and narrower job: **a learner who is present but not writing** — reading a debrief, watching a replay. Those produce `pointermove` and `scroll` and no writes at all, and they are exactly who the throttle in `API_WALKTHROUGH.md` §3.3 is built for. Do not drop the beat on the grounds that writes now cover liveness; they do not cover a learner who is only reading.  Only this route returns `expires_at`, so a client\'s idea of its own expiry is a lower bound between beats. That is harmless — it under-estimates — but it is why the beat is also how a client learns where it stands.  Send this on a **leading-edge throttle** driven by interface activity — at most one per 60s — not on a trailing debounce, which would fire only after activity stops and let a continuously-playing learner be swept mid-attempt. 
     * Keep the visit alive
     */
    async heartbeatMyLearnVisitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HeartbeatMyLearnVisit200Response>> {
        const requestOptions = await this.heartbeatMyLearnVisitRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HeartbeatMyLearnVisit200ResponseFromJSON(jsonValue));
    }

    /**
     * Refreshes `last_seen_at` and extends the Visit token\'s TTL. A Visit that stops heartbeating past the session\'s `visit_idle_timeout_seconds` is marked `abandoned` by the idle sweep, which frees the kiosk device. The sweep also mints that visit\'s take-home links, so a tablet that merely slept can still hand its learner their work.  **Every learner write does both of these too** — refreshes `last_seen_at` *and* extends the TTL. One rule: a learner write means the learner is here, for both purposes. The two must move together; refreshing liveness alone would let a Visit be demonstrably active — writes flowing, the sweep never touching it — while its token died at a fixed 900s from mint, producing a bare `401` mid-activity with no links minted and nothing recoverable until the sweep caught up 300s after the learner gave up.  That leaves this route a real and narrower job: **a learner who is present but not writing** — reading a debrief, watching a replay. Those produce `pointermove` and `scroll` and no writes at all, and they are exactly who the throttle in `API_WALKTHROUGH.md` §3.3 is built for. Do not drop the beat on the grounds that writes now cover liveness; they do not cover a learner who is only reading.  Only this route returns `expires_at`, so a client\'s idea of its own expiry is a lower bound between beats. That is harmless — it under-estimates — but it is why the beat is also how a client learns where it stands.  Send this on a **leading-edge throttle** driven by interface activity — at most one per 60s — not on a trailing debounce, which would fire only after activity stops and let a continuously-playing learner be swept mid-attempt. 
     * Keep the visit alive
     */
    async heartbeatMyLearnVisit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HeartbeatMyLearnVisit200Response> {
        const response = await this.heartbeatMyLearnVisitRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putMyLearnArtifact without sending the request
     */
    async putMyLearnArtifactRequestOpts(requestParameters: PutMyLearnArtifactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['artifactId'] == null) {
            throw new runtime.RequiredError(
                'artifactId',
                'Required parameter "artifactId" was null or undefined when calling putMyLearnArtifact().'
            );
        }

        if (requestParameters['learnArtifactCreate'] == null) {
            throw new runtime.RequiredError(
                'learnArtifactCreate',
                'Required parameter "learnArtifactCreate" was null or undefined when calling putMyLearnArtifact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/artifacts/{artifactId}`;
        urlPath = urlPath.replace('{artifactId}', encodeURIComponent(String(requestParameters['artifactId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LearnArtifactCreateToJSON(requestParameters['learnArtifactCreate']),
        };
    }

    /**
     * Replace an artifact
     */
    async putMyLearnArtifactRaw(requestParameters: PutMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnArtifact>> {
        const requestOptions = await this.putMyLearnArtifactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnArtifactFromJSON(jsonValue));
    }

    /**
     * Replace an artifact
     */
    async putMyLearnArtifact(requestParameters: PutMyLearnArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnArtifact> {
        const response = await this.putMyLearnArtifactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putMyLearnAttemptState without sending the request
     */
    async putMyLearnAttemptStateRequestOpts(requestParameters: PutMyLearnAttemptStateOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attemptId'] == null) {
            throw new runtime.RequiredError(
                'attemptId',
                'Required parameter "attemptId" was null or undefined when calling putMyLearnAttemptState().'
            );
        }

        if (requestParameters['putMyLearnAttemptStateRequest'] == null) {
            throw new runtime.RequiredError(
                'putMyLearnAttemptStateRequest',
                'Required parameter "putMyLearnAttemptStateRequest" was null or undefined when calling putMyLearnAttemptState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/attempts/{attemptId}/state`;
        urlPath = urlPath.replace('{attemptId}', encodeURIComponent(String(requestParameters['attemptId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutMyLearnAttemptStateRequestToJSON(requestParameters['putMyLearnAttemptStateRequest']),
        };
    }

    /**
     * Optimistic concurrency. Send the `version` you last read; the server bumps it on success. A mismatch returns 409 — which is what stops two kiosk tabs on the same Visit from silently clobbering each other. 
     * Replace attempt state
     */
    async putMyLearnAttemptStateRaw(requestParameters: PutMyLearnAttemptStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnAttempt>> {
        const requestOptions = await this.putMyLearnAttemptStateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnAttemptFromJSON(jsonValue));
    }

    /**
     * Optimistic concurrency. Send the `version` you last read; the server bumps it on success. A mismatch returns 409 — which is what stops two kiosk tabs on the same Visit from silently clobbering each other. 
     * Replace attempt state
     */
    async putMyLearnAttemptState(requestParameters: PutMyLearnAttemptStateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnAttempt> {
        const response = await this.putMyLearnAttemptStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for runMyLearnRobot without sending the request
     */
    async runMyLearnRobotRequestOpts(requestParameters: RunMyLearnRobotOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['attemptId'] == null) {
            throw new runtime.RequiredError(
                'attemptId',
                'Required parameter "attemptId" was null or undefined when calling runMyLearnRobot().'
            );
        }

        if (requestParameters['runMyLearnRobotRequest'] == null) {
            throw new runtime.RequiredError(
                'runMyLearnRobotRequest',
                'Required parameter "runMyLearnRobotRequest" was null or undefined when calling runMyLearnRobot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me/attempts/{attemptId}/robot-run`;
        urlPath = urlPath.replace('{attemptId}', encodeURIComponent(String(requestParameters['attemptId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunMyLearnRobotRequestToJSON(requestParameters['runMyLearnRobotRequest']),
        };
    }

    /**
     * Executes the learner\'s script as the \"robot\" role in single-player smiley play. The prompt, model choice, and provider key are server-side only and never reach the client.  **This endpoint does not touch `state` or `version`.** The run is persisted in `learn_robot_runs` (a backend-owned table — writing it into the opaque, frontend-owned `state` would require the backend to know that schema), so the `version` you were holding before the call is still current after it. Your save loop does not need to re-read.  **Write the result into `state` yourself, with your next ordinary `PUT`.** That is what makes it survive a reload, and it is why the backend does not do it for you. Copy it into the Artifact payload too if the learner keeps the attempt — take-home replay reads the artifact, never this table, which is what keeps a replay from re-invoking the model.  **This endpoint never returns 5xx for provider failure or exhausted budget.** It degrades to a deterministic canned robot and sets `degraded: true`. There is no `budget_exhausted` error slug for the same reason — an exhausted cap is a `200`, not a failure.  A `429` here carries `detail: robot_rate_limited` and a `Retry-After` header. 
     * Run the adversarial robot
     */
    async runMyLearnRobotRaw(requestParameters: RunMyLearnRobotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RobotRunResult>> {
        const requestOptions = await this.runMyLearnRobotRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RobotRunResultFromJSON(jsonValue));
    }

    /**
     * Executes the learner\'s script as the \"robot\" role in single-player smiley play. The prompt, model choice, and provider key are server-side only and never reach the client.  **This endpoint does not touch `state` or `version`.** The run is persisted in `learn_robot_runs` (a backend-owned table — writing it into the opaque, frontend-owned `state` would require the backend to know that schema), so the `version` you were holding before the call is still current after it. Your save loop does not need to re-read.  **Write the result into `state` yourself, with your next ordinary `PUT`.** That is what makes it survive a reload, and it is why the backend does not do it for you. Copy it into the Artifact payload too if the learner keeps the attempt — take-home replay reads the artifact, never this table, which is what keeps a replay from re-invoking the model.  **This endpoint never returns 5xx for provider failure or exhausted budget.** It degrades to a deterministic canned robot and sets `degraded: true`. There is no `budget_exhausted` error slug for the same reason — an exhausted cap is a `200`, not a failure.  A `429` here carries `detail: robot_rate_limited` and a `Retry-After` header. 
     * Run the adversarial robot
     */
    async runMyLearnRobot(requestParameters: RunMyLearnRobotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RobotRunResult> {
        const response = await this.runMyLearnRobotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMyLearnVisit without sending the request
     */
    async updateMyLearnVisitRequestOpts(requestParameters: UpdateMyLearnVisitOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateMyLearnVisitRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMyLearnVisitRequest',
                'Required parameter "updateMyLearnVisitRequest" was null or undefined when calling updateMyLearnVisit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Learner-Token"] = await this.configuration.apiKey("X-Learner-Token"); // learnerToken authentication
        }


        let urlPath = `/learn/visits/me`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMyLearnVisitRequestToJSON(requestParameters['updateMyLearnVisitRequest']),
        };
    }

    /**
     * Supports late naming and a second player arriving after the visit has started.
     * Update participants or team name
     */
    async updateMyLearnVisitRaw(requestParameters: UpdateMyLearnVisitOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LearnVisit>> {
        const requestOptions = await this.updateMyLearnVisitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearnVisitFromJSON(jsonValue));
    }

    /**
     * Supports late naming and a second player arriving after the visit has started.
     * Update participants or team name
     */
    async updateMyLearnVisit(requestParameters: UpdateMyLearnVisitOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LearnVisit> {
        const response = await this.updateMyLearnVisitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
